import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import QuilityAPI from '../../../store/API/QuilityAPI';
import FmlQuestionSet from '../../../FML/views/FmlQuestionSet.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormRenderer',
  props: {
    slug: null,
    hideSubmitButton: { type: Boolean }
  },
  emits: ["saved"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'saved'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  slug?: string,
  hideSubmitButton?: boolean
}





const form = ref<any>(null)

const load = () => {
  QuilityAPI.getFormWithSlug(props.slug, 'new', ['SingleEntryResponse'])
    .then((data: any) => {
        form.value = data
    })
}

watch(() => props.slug, () => {
  form.value = null
  if (!props.slug) {
    return
  }

  load()
}, { immediate: true })

return { __sfc: true,props, emit, form, load, FmlQuestionSet }
}

})